import type { CatalogParameterDto } from 'api/catalogParameters/models/CatalogParameterDto';
import { FamilyDto } from 'api/families/models/FamilyDto';
import { ParameterSectionBaseModel } from 'common/components/parametersSections/models';
import { SearchableSelectTitleSubTitleOption } from 'common/components/searchableSelectInput/optionsFormats/OptionTitleSubTitle';
import { createContext } from 'react';

interface FamilyParameterDataProviderModel {
    family?: Partial<FamilyDto>;
    units: SearchableSelectTitleSubTitleOption[];
    familiesInputOptions: SearchableSelectTitleSubTitleOption[];
    selectedSectionKey: string;
    sections: ParameterSectionBaseModel[];
    weightUnitId: string | null;
    catalogParameters: CatalogParameterDto[];
    onCatalogParameterCreated: (param: CatalogParameterDto) => void;
}

const defaultValue: FamilyParameterDataProviderModel = {
    familiesInputOptions: [],
    units: [],
    selectedSectionKey: '',
    sections: [],
    weightUnitId: null,
    catalogParameters: [],
    onCatalogParameterCreated: () => {},
}

export const FamilyParameterDataProvider = createContext(defaultValue);
